export default (elem) => elem && document.body.contains(elem);
